module.exports = __webpack_public_path__ + "img/web_chahua_team@2.44c7fe96.png";